import React, { useEffect, useState, useMemo } from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// material-ui icons
import Assignment from "@material-ui/icons/Assignment";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardIcon from "components/Card/CardIcon.js";
import CardHeader from "components/Card/CardHeader.js";
import Button from "components/CustomButtons/Button.js";
import { MantineReactTable } from "mantine-react-table";
import LoopIcon from '@mui/icons-material/Loop';
// import Person from "@material-ui/icons/Person";
// import Edit from "@material-ui/icons/Edit";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import {
  Box,
  ActionIcon,
  Tooltip,
  Modal,
  Flex,
  Title,
  Stack,
  TextInput
} from "@mantine/core";
import { IconDownload, IconEye } from "@tabler/icons-react";
import { ExportToCsv } from "export-to-csv"; //or use your library of choice here
import { IconTrash, IconEdit } from "@tabler/icons-react";

import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import { useNavigate } from "react-router-dom";
import axios from "../../utils/axiosInstance"; 

import SweetAlert from "react-bootstrap-sweetalert";
import stylesData from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";
import moment from "moment";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { TextField } from "@mui/material";
import { CircularProgress, Typography } from "@material-ui/core";
import Pagination from "rc-pagination";
const useStyles = makeStyles(styles);

export default function ManagePayout() {
  const [openView, setOpenView] = useState(false);
  const classes = useStyles();
  const [selectedData, setSelectedData] = useState({ status: -1, remark: "", payoutReqId: "" });
  const [loading, setLoading] = useState(false);
  const [loadingPatch, setLoadingPatch] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  console.log(selectedData, "selectedData");
  const statusLabels = {
    2: "Approve",
    3: "Reject"
  };

  const validationSchema = Yup.object({
    status: Yup.number()
      .min(0, "Please select a status")
      .required("Status is required"),
    remark: Yup.string().trim().required("Remark is required")
  });
  const navigate = useNavigate();
  const columns = useMemo(() => [

    {
      header: "Ticket Number",
      accessorKey: "ticketNumber",
      size: 10,
    },

    {
      header: "Lottery Name",
      accessorKey: "lotteryName",
      size: 10,
    },
    {
      header: "Player",
      accessorKey: "userName",
      size: 10,
    },
    {
      header: "Prize Money Amount",
      accessorKey: "lotteryWinningPrize",
      size: 10,
    },
    {
      header: "Commission Amount (20%)",
      accessorKey: "commissionAmount",
      size: 10,
    },
    {
      header: "Payout Amount (80%)",
      accessorKey: "payoutAmount",
      size: 10,
    },
    {
      header: "Status",
      accessorKey: "status",
      size: 10,
      Cell: ({ cell }) => {
        const statusMap = {
          0: "Pending",
          1: "Initiated",
          2: "Aprroved",
          3: "Rejected"
        };

        return statusMap[cell.getValue()] ?? "Unknown";
      }
    }
  ]);
  const [values, setValues] = useState(() =>
    columns?.reduce((acc, column) => {
      acc[column.accessorKey ?? ""] = "";
      return acc;
    })
  );
  const [tableData, setTableData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  console.log(tableData, "tableData")
  const handleWithdrawDetailModal = async (rows) => {
    navigate(
      `/admin/userWithdrawRequest/${rows.original.withdrawData.paymentId}`
    );
  };
  useEffect(() => {
    getData();
  }, []);

  const getData = async (page = 1, limit = pageSize) => {
    const token = localStorage.getItem("token");
    await axios
      .get(
        `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/manage-payout?page=${page}&limit=${limit}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Access-Control-Allow-Origin": "*"
          }
        }
      )
      .then((res) => {
        const data = res.data.data;
        console.log(data);

        setTableData(data.data);
        const meta = data.metaData?.[0];
        if (meta) {
          setCurrentPage(meta.page);
          setPageSize(meta.limit);
          setTotalItems(meta.total);
        }
        setLoading(false)
      })
      .catch((err) => {
        console.log(err);
        if (
          err.response.data.message ==
          "For security reasons, we locked your account.Please login to continue"
        ) {
          localStorage.removeItem("token");
          window.location.assign("/auth/login-page");
        }
      });
  };

  const handleClickAction = async (row) => {
    setIsOpen(true);
    setSelectedData({ ...selectedData, payoutReqId: row.original.transactionId });
    console.log(row.original._id, "row.original._id", isOpen);
  };

  const handleSubmit = async (values) => {
    const token = localStorage.getItem("token");
    try {

      await axios.patch(
        `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/action-request`,
        { ...values, payoutReqId: selectedData.payoutReqId },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Access-Control-Allow-Origin": "*"
          }
        }
      )
      getData();
    } catch (error) {
      console.error("Submission failed:", error);
    }

  };
  const handlePageChange = (page) => {
    setCurrentPage(page);
   
    getData(page, pageSize); 
  };

  return (
    <>
      <GridContainer>
        <GridItem xs={12}>
          <Card>
            <CardHeader color="rose" icon>
              <CardIcon color="rose">
                <Assignment />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>Manage Payout</h4>
            </CardHeader>
            <CardBody>
              <MantineReactTable
                columns={columns}
                displayColumnDefOptions={{
                  "mrt-row-actions": {
                    header: (
                      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "6px" }}>
                        <span>Actions</span>
                        <LoopIcon size={18} style={{ cursor: "pointer" }} className={loading && "rotating-icon"} onClick={() => { setLoading(true); getData() }} />

                      </div>
                    ),
                    mantineTableHeadCellProps: {
                      align: "center"
                    },
                    size: 120
                  }
                }}
                enableColumnFilterModes
                initialState={{ showColumnFilters: true }}
                positionToolbarAlertBanner="bottom"
                data={tableData}
                enableEditing
                enableFullScreenToggle={false}
                enableHiding={false}
                enableDensityToggle={false}
                enableFilters={false}
                enablePagination={false}
                renderRowActions={({ row }) => (
                  <Box
                    sx={{
                      display: "flex",
                      gap: "16px"
                    }}
                  >
                    <Tooltip withArrow position="left" label="View">
                      <Button
                        disabled={
                          row.original.status === 2 || row.original.status === 3
                        }
                        onClick={() => handleClickAction(row)}
                        style={{
                          backgroundColor: "#228be6",
                          fontWeight: "bold"
                        }}
                      >
                        Action
                      </Button>
                    </Tooltip>
                  </Box>
                )}
                positionActionsColumn="first"
                renderTopToolbarCustomActions={({ table }) => (
                  <Box
                    sx={{
                      display: "flex",
                      gap: "16px",
                      padding: "8px",
                      flexWrap: "wrap"
                    }}
                  >
                    
                  </Box>
                )}
              />
            </CardBody>
            <Box sx={{
              display: "flex",
              justifyContent: "flex-end",
            
            }}>
              <Pagination
                current={currentPage}
                total={totalItems}
                pageSize={pageSize}
                onChange={handlePageChange}
                showQuickJumper
                showTotal={(total, range) => `${range[0]}-${range[1]} of ${total} items`}
              />
            </Box>
          </Card>

        </GridItem>


      </GridContainer>
      <Modal
        opened={isOpen}
        centered
        size={"lg"}
        title="Manage Request"
        className="modalHeaderCss"
        onClose={() => {
          setIsOpen(false);
          setSelectedData({ status: -1, remark: "", payoutReqId: "" });
        }}
      >
        {isOpen && (
          <Formik
            initialValues={{ status: -1, remark: "" }}
            validationSchema={validationSchema}
            onSubmit={async (values, { resetForm }) => {
              setLoadingPatch(true);
              try {
                await handleSubmit(values);
                resetForm();
                setIsOpen(false);
                setSelectedData({ status: -1, remark: "", payoutReqId: "" });
              } catch (error) {
                console.error("Submission error:", error);
              } finally {
                setLoadingPatch(false);
              }
            }}
          >
            {({ values, errors, touched, handleChange, handleBlur }) => (
              <Form>
                <Stack sx={{ width: "100%", paddingInline: "20px" }}>
                  {/* Status Dropdown */}
                  <Box
                    sx={{
                      display: "flex",
                      flexFlow: "column",
                      gap: "4px",
                      width: "100%"
                    }}
                  >
                    <Typography
                      variant="h6"
                      textTransform="capitalize"
                      sx={{
                        fontWeight: 500,
                        fontFamily: "'Roboto', sans-serif"
                      }}
                    >
                      Status
                    </Typography>
                    <FormControl
                      sx={{ m: 0, minWidth: 120 }}
                      size="medium"
                      error={touched.status && Boolean(errors.status)}
                    >
                      <Select
                        name="status"
                        value={values.status}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      >
                        <MenuItem disabled value={-1}>
                          Select Status
                        </MenuItem>
                        <MenuItem value={2}>Approved</MenuItem>
                        <MenuItem value={3}>Rejected</MenuItem>
                      </Select>
                      {touched.status && errors.status && (
                        <FormHelperText>{errors.status}</FormHelperText>
                      )}
                    </FormControl>
                  </Box>

                  {/* Remark Input */}
                  <Box
                    sx={{
                      display: "flex",
                      flexFlow: "column",
                      gap: "4px",
                      width: "100%",
                      marginTop: "16px"
                    }}
                  >
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: 500,
                        fontFamily: "'Roboto', sans-serif",
                        textTransform: "capitalize"
                      }}
                    >
                      Remark
                    </Typography>
                    <TextField
                      name="remark"
                      rows={4}
                      multiline
                      value={values.remark}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={touched.remark && Boolean(errors.remark)}
                      helperText={touched.remark && errors.remark}
                    />
                  </Box>


                  <Box
                    sx={{
                      padding: "20px",
                      width: "100%",
                      display: "flex",
                      justifyContent: "flex-end",
                      gap: "16px"
                    }}
                  >
                    {loadingPatch ? (
                      <div style={{ textAlign: 'center', padding: '20px' }}>
                        <CircularProgress />
                      </div>
                    ) : (
                      <Button
                        type="submit"
                        variant="subtle"
                        disabled={values.status === -1 || !values.remark.trim()}
                        sx={{
                          fontSize: '18px',
                          textTransform: 'capitalize',
                        }}

                      >
                        {statusLabels[values.status] || "Choose"}
                      </Button>
                    )}

                  </Box>
                </Stack>
              </Form>
            )}
          </Formik>
        )}
      </Modal>
    </>
  );
}
